import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { EmployeeRecordSelect } from "../../shared/EmployeeRecordSelect";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyEmployeeRecordProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyEmployeeRecord = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyEmployeeRecordProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    useEffect(() => {
        onChange(customProperty.label, value);
    }, [value]);

    // console.log("[AppCustomPropertyEmployeeRecord] validate: ", validate);
    // console.log("[AppCustomPropertyEmployeeRecord] value: ", value);
    // console.log("[AppCustomPropertyEmployeeRecord] customProperty.required: ", customProperty.required);

    return (
        <div className="app-custom-property-employee-record">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               <EmployeeRecordSelect 
                    selected={data}
                    disabled={disabled}
                    onChange={(value: any) => {
                        console.log("Manager: ", value);
                        onChange(customProperty.label, value);
                    }}
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !value && customProperty.required}
                />
            </div>
        </div>
    )
}
